import {
  Component,
  Input,
  OnInit
}                             from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { CodeTypeModel }            from '../core/models/code-type';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { ConfirmService }           from '../messages/confirm/confirm.service';
import { MessagesService }          from '../messages/messages.service';
import { StripeAccountLinkModel }   from './models/stripe.account-link';
import { StripeAccountModel }       from './models/stripe.account';
import { StripeService }            from './stripe.service';

@Component({
  selector   : 'wor-stripe-settings',
  template: require('./stripe.settings.component.html')
})
export class StripeSettingsComponent implements OnInit {
  @BlockUI('stripeSettingsBlock') block : NgBlockUI;

  @Input() settings : CompanyIntegrationsModel;

  account  : StripeAccountModel   = null;
  accounts : Array<CodeTypeModel> = [];
  enabling : boolean              = false;

  constructor (
    public  companyService  : CompanyService,
    private confirmService  : ConfirmService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    public  stripeService   : StripeService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    if (this.stripeService.isLinked()) {
      this.enabling = true;

      this.stripeService.get()
      .then(( account : StripeAccountModel ) => {
        this.account = account;

        return ( this.stripeService.isActive(this.account) && !this.companyService.hasIntegration('stripe') )
          ? this.stripeService.enable()
            .then(() => {
              this.router.stateService.reload();

              return true;
            })
          : Promise.resolve(true);
      })
      .finally(() => {
        this.enabling = false;
      });
    }

    if (this.stripeService.hasAccounting()) {
      this.block.start();

      this.stripeService.getAccounts()
      .then(( accounts : Array<CodeTypeModel> ) => {
        this.accounts = accounts;
      })
      .finally(() => {
        this.block.stop();
      });
    }
  }

  connect () : void {
    this.stripeService.connect()
    .then(( account : StripeAccountLinkModel ) => {
      window.location.assign(account.url);
    });
  }

  disable () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'WorkshopPay' }))
    .then(() => this.stripeService.disable())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', { name: 'WorkshopPay' }), 'success');

      /**
       * For australian customers who don't have stripe enabled,
       * they cannot activate stripe and must use workshopPay instead.
       * So once they deactivate, redirect them away from stripe
       * settings since it is no longer available to them.
       * Reference: WOR-2560
       */
      if (this.companyService.country('australia')) {
        this.router.stateService.go('app');
      }
      else {
        this.router.stateService.reload();
      }
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }

  save () : void {
    this.stripeService.saveSettings(this.settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }
}
